import React from 'react';
import NumberLabel from "../components/NumberLabel/NumberLabel";
import PropTypes from 'prop-types';
import AppVariables from '../common/AppVariables';
import Utils from "./Utils";

export const FARM_SIZE_UNIT = AppVariables.FarmSizeUnit;
export const FARM_SIZE_PROPERTY = `${AppVariables.FarmSizeUnit}s`;
export const FARM_SIZE_LABEL = Utils.ucFirst(FARM_SIZE_PROPERTY);

const FarmSizeLabel = ({ value , item }) => {
    value = value || ((item !== undefined) ? item[FARM_SIZE_PROPERTY] : null);
    return <span><NumberLabel value={value}/> {FARM_SIZE_UNIT}{isFinite(value) && (Number(value) !== 1) ? 's' : '' }</span>
};

FarmSizeLabel.propTypes = {
    value: PropTypes.any,
    item: PropTypes.any
};


export default FarmSizeLabel;


// WEBPACK FOOTER //
// ./src/common/FarmSizeLabel.js